import apiClient from "./apiClient";

const taskApi = apiClient('');

const TaskApi = {
    /**
     * Получить все задачи (сгруппированные по промо)
     */
    async getAllTasks() {
        const response = await taskApi.get('/tasks');
        return response.data;
    },

    /**
     * Создать/обновить задачи для промо
     * @param {number} promoId 
     * @param {Array<{title: string, details?: string}>} tasks 
     */
    async createTasksForPromo(promoId, tasks) {
        const response = await taskApi.post(`/tasks/promo/${promoId}`, { tasks });
        return response.data;
    },

    /**
     * Получить задачи для конкретного промо
     * @param {number} promoId 
     */
    async getTasksByPromo(promoId) {
        const response = await taskApi.get(`/tasks/promo/${promoId}`);
        return response.data;
    },

    /**
     * Выполнить задачу
     * @param {number} promoId 
     * @param {number} taskId 
     */
    async completeTask(promoId, taskId) {
        const response = await taskApi.post('/tasks/complete', {
            promo_id: promoId,
            task_id: taskId,
        });
        return response.data;
    },

    /**
     * Получить прогресс текущего пользователя по задачам промо
     * @param {number} promoId 
     */
    async getMyProgress(promoId) {
        const response = await taskApi.get(`/tasks/promo/${promoId}/my-progress`);
        return response.data;
    },

    /**
     * Получить прогресс конкретного пользователя (для админов)
     * @param {number} promoId 
     * @param {number} userId 
     */
    async getUserProgress(promoId, userId) {
        const response = await taskApi.get(`/tasks/promo/${promoId}/user/${userId}`);
        return response.data;
    },

    async getDefaultTasks() {
        const response = await taskApi.get('/tasks/defaults');
        return response.data;
    },

    async getDefaultTasksProgress() {
        const response = await taskApi.get('/tasks/defaults/my-progress');
        return response.data;
    },

    async completeDefaultTask(defaultTaskId) {
        const response = await taskApi.post('/tasks/defaults/complete', {
            default_task_id: defaultTaskId,
        });
        return response.data;
    },
};

export default TaskApi;
